var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contacts-item-link",class:{ 'contact-page': _vm.isContactPage },attrs:{"href":_vm.href}},[_c(`icon-${_vm.type}`,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }